import logo from '../../assets/img/logo.png';
import loadingGif from '../../assets/img/loading.gif';
import React, { useState, Fragment } from "react";
import axios from "axios";
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import Swal from 'sweetalert2'
import Container from 'react-bootstrap/Container';
import { ToastContainer } from "react-toastify";
import * as CryptoJS from 'crypto-js';

export default function ActivatePassword() {

    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [sifreGuncellendi, setSifreGuncellendi] = useState(0);

    function PasswordValidate (password) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.,@#\$%\^&\*])(?=.{8,})/.test(password);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (userName === "" || password === "" || password2 === "") {
            Swal.fire({ title: "Hata", text: "Lütfen tüm alanları doldurunuz", icon: "error" });
            return;
        }

        if (password !== password2) {
            Swal.fire({ title: "Hata", text: "Şifrenizin birini farklı girdiniz", icon: "error" });
            return;
        }

        if (password.length < 8) {
            Swal.fire({ title: "Hata", text: "Girdiğiniz şifre, şifre oluşturma kurallarına uygun değil", icon: "error" });
            return;
        }

        if (PasswordValidate(password) === false) {
            Swal.fire({ title: "Hata", text: "Girdiğiniz şifre, şifre oluşturma kurallarına uygun değil", icon: "error" });
            return;
        }

        const kod = window.location.href.split("?C=")[1];

        if (!kod) {
            Swal.fire({ title: "Hata", text: "Aktivasyon kodu hatalı", icon: "error" });
            return;
        }

        let key = CryptoJS.enc.Utf8.parse("TedasBasinCimer*");
        let encryptedBytes = CryptoJS.AES.encrypt(password, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
        let encryptedString = encryptedBytes.toString();

        const postData = JSON.stringify({
            "mail": userName,
            "password": encryptedString,
            "password2": encryptedString,
            "aktivasyonKodu": kod
        });

        axios.post(settings.ApiUrl + 'Login/UpdatePasswordByAktivasyonKodu/', postData, { headers: { 'Content-Type': 'application/json' }, withCredentials: false })
            .then((result) => {
                setLoading(false);
                setUserName("");
                setPassword("");
                setPassword2("");

                if (result.data.success) {
                    if (result.data.value === "KayitYok") {
                        Swal.fire({ title: "Hata", text: "Hata oluştu", icon: "error" });
                    } else {
                        setSifreGuncellendi(1);
                    }
                } else {
                    Swal.fire({ title: "Hata", text: result.data.message, icon: "error" });
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
                Swal.fire({ title: "Hata", text: error, icon: "error" });
            });
    };

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>

                <input tabIndex="-1" style={{position: "absolute", top: "-1000px"}} type="text"></input>
                <input tabIndex="-1" style={{position: "absolute", top: "-1000px"}} type="password"></input>
                
                <div>
                    {
                        loading ?
                            <div className="progressBackground">
                                <div className="progressPopup">
                                    <img alt="Bekleyiniz..." src={loadingGif} width="100" height="100" />
                                </div>
                            </div>
                            :
                            ''
                    }

                    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                    <div className="d-flex justify-content-center py-4">
                                        <a href="https://www.tedas.gov.tr" className="logo d-flex align-items-center w-auto">
                                            <img src={logo} alt=""></img>
                                        </a>
                                    </div>

                                    <div className="card mb-3">

                                        <div className="card-body">

                                            <div className="pt-2 pb-2">
                                                <h5 className="card-title text-center pb-0 fs-4">ATGroup</h5>
                                            </div>

                                            <div className="row g-3 needs-validation">

                                                <div className="col-12" style={{display: (sifreGuncellendi === 0 ? "block" : "none") }}>
                                                    <div className="alert alert-warning mb-0 text-center" style={{ fontSize: "medium" }}>
                                                        Şifreniz en az 8 karakterden oluşmalı, en az birer büyük harf, küçük harf, rakam ve sembol içermelidir.
                                                    </div>
                                                </div>

                                                <div className="col-12" style={{display: (sifreGuncellendi === 0 ? "block" : "none") }}>
                                                    <label htmlFor="tbCart" className="form-label">E-Posta</label>
                                                    <div className="input-group has-validation">
                                                        <span className="input-group-text" id="inputGroupPrepend"><i className="bi bi-person-fill"></i></span>
                                                        <input id="tbCart" name="cart" className="form-control" value={userName} onChange={(e) => setUserName(e.target.value)}
                                                            type="text" placeholder="E-posta adresiniz" autoComplete="off" required />
                                                        <div className="invalid-feedback">E-posta adresiniz giriniz.</div>
                                                    </div>
                                                </div>

                                                <div className="col-12" style={{display: (sifreGuncellendi === 0 ? "block" : "none") }}>
                                                    <label htmlFor="tbPassword" className="form-label">Şifreniz</label>
                                                    <div className="input-group has-validation">
                                                        <span className="input-group-text"><i className="bi bi-key-fill"></i></span>
                                                        <input id="tbPassword" name="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)}
                                                            type="password" placeholder="Yeni şifreniz" autoComplete="off" required />
                                                        <div className="invalid-feedback">Yeni şifrenizi giriniz.</div>
                                                    </div>
                                                </div>

                                                <div className="col-12" style={{display: (sifreGuncellendi === 0 ? "block" : "none") }}>
                                                    <label htmlFor="tbPassword2" className="form-label">Şifrenizi Tekrar Giriniz</label>
                                                    <div className="input-group has-validation">
                                                        <span className="input-group-text"><i className="bi bi-key-fill"></i></span>
                                                        <input id="tbPassword2" name="password2" className="form-control" value={password2} onChange={(e) => setPassword2(e.target.value)}
                                                            type="password" placeholder="Şifrenizi tekrar giriniz" autoComplete="off" required />
                                                        <div className="invalid-feedback">Yeni şifrenizi tekrar giriniz.</div>
                                                    </div>
                                                </div>

                                                <div className="col-12" style={{display: (sifreGuncellendi === 0 ? "block" : "none") }}>
                                                    <button className="btn btn-primary btn-block w-100" onClick={handleSubmit}>Şifre Oluştur</button>
                                                </div>

                                                <div className="col-12" style={{display: (sifreGuncellendi === 1 ? "block" : "none") }}>
                                                    <div className="alert alert-success mb-0 text-center" style={{ fontSize: "smaller" }}>
                                                        Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                    <div className="credits">
                                        <a href="/" style={{ fontWeight: '600' }}>Giriş Sayfası</a>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </section>

                </div>

            </Container>
        </Fragment>
    );
}